import { Col, Row } from 'reactstrap'
import { URL } from '../../../../api'
import { LineCount } from '../../../../utilities/line-count'

const StationsPage = ({ data, lang }) => {
    return (
        <div className="solutions-container">
            <div className="textJustifyCenter mt-5">
                <div className="solution-title f24 d-flex align-items-center justify-content-center mb-5">
                    <span className='color10 fw500 f32'>{data?.description[lang]}</span>
                </div>
            </div>
            <Row>
                {
                    (data?.modules ? [...data?.modules] : [])
                        .sort((a, b) => a.sort ? a.sort - b.sort : a.id - b.id)
                        .map((item, index) => {
                            return (
                                <Col xs={12} sm={12} md={LineCount(data?.lineCount)} lg={LineCount(data?.lineCount)} xl={LineCount(data?.lineCount)} key={index} className="mb-3">
                                    <div className="solution-item">
                                        <div className="solution-image">
                                            <img src={`${URL}${item?.files[0]}`} alt={item?.title[lang]} className="w-100" loading="lazy" />
                                        </div>
                                        <div className="solution-details d-flex align-items-center mt-3">
                                            <div className='mt-2 mb-2'>
                                                <img
                                                    src={`${URL}${item?.files[1]}`}
                                                    alt=""
                                                    style={{ width: '24px', height: '24px', marginLeft: "10px", }}
                                                    loading="lazy"
                                                />
                                                <span className='mb-0'>{item?.description[lang]}</span>
                                            </div>
                                        </div>
                                        <div>
                                            <h4 className='mb-0'>{item?.title[lang]}</h4>
                                        </div>
                                    </div>
                                </Col>
                            )
                        })
                }
            </Row>
        </div>
    )
}

export default StationsPage
